import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { UncontrolledCollapse, Button } from "reactstrap";

import * as flightDetailsActions from "../actions/flightDetails";
import * as StationsActions from "../actions/stationNames";
import FlightCard from "../components/flightDetail/flightCard";
import Modal from "../components/modal/parent";
import * as config from "../data/config";
import LocalStorageHelper from "../common/localStorageHelper";

class FlightDetails extends Component {
    componentDidMount() {
        // fetch data
        //OLD this.props.actions.getFlightData(this.props.flightFilters)
        // console.info("conatiners flightsdetails this.props.flightFilters", this.props.flightFilters);
    }

    render() {
        let { filteredFlightDetails, onShowModal, testData, serverOffSet, refreshedTime } = this.props;

        let depEdctDiffTime;
        let turnAroundTimeFinal;
        let yellowWarningE2; //30 mins
        let yellowWarningDash8; // 5 mins
        let yellowWarning;

        let kjsnd = this.props.JSONStringList;

        let LocalStorageselectedStation = LocalStorageHelper.selectedStation.get();

        kjsnd.map((m) => {
            if (m.iataCode == LocalStorageselectedStation) {
                depEdctDiffTime = m.depEdctMinutesDiff;
            }
        });

        // console.info("hhdh", turnAroundTimeFromAPI);

        if (testData != null) {
            filteredFlightDetails = testData.flightDetails;
        }

        var moment = require("moment");

        function realEDT(o, edct) {
            //If the flight has edct time, overwrite original edt for sorting
            if (edct != null) {
                o.ETD_Outbound = moment(o.EDCT_Outbound).subtract(depEdctDiffTime, "minutes");
            }
            return moment(o.ETD_Outbound);
        }

        function sortFlightCard(arr) {
            const flightCards = []
                .concat(arr)
                .sort((a, b) => (realEDT(a, a.EDCT_Outbound) > realEDT(b, b.EDCT_Outbound) ? 1 : -1))
                .map((fd, i) => {
                    kjsnd.map((k) => {
                        if (fd.ModelOutbound == "DHC8-402") {
                            if (k.iataCode == LocalStorageselectedStation) {
                                //dash8 model type
                                turnAroundTimeFinal = config.environment.targetTurnTime.Dash8; //k.targetTurnTime[0].dash8;
                                yellowWarning = 5;
                                // console.info("hshfdjfhshfhud if", fd.ModelOutbound);
                                // console.info("hshfdjfhshfhud if", yellowWarning);
                            }
                        } else {
                            if (k.iataCode == LocalStorageselectedStation) {
                                //e2 model type
                                turnAroundTimeFinal = config.environment.targetTurnTime.E195; //k.targetTurnTime[0].e2;
                                yellowWarning = 5;
                                // console.info("hshfdjfhshfhud else", fd.ModelOutbound);
                                // console.info("hshfdjfhshfhud else", yellowWarning);
                            }
                        }
                    });
                    return (
                        <FlightCard
                            flightDetail={fd}
                            key={fd.LegHashKeyInbound + "_" + fd.LegHashKeyOutbound + "_" + i}
                            onShowModal={onShowModal}
                            serverOffSet={serverOffSet}
                            depEdctDiffTime={depEdctDiffTime}
                            turnAroundTimeFinal={turnAroundTimeFinal}
                            yellowWarning={yellowWarning}
                        />
                    );
                }, this);
            return flightCards;
        }
        return (
            <div>
                {(!filteredFlightDetails || filteredFlightDetails?.length == 0) && (
                    <div>No flight records found. Try changing search or filter criteria.</div>
                )}
                {sortFlightCard(filteredFlightDetails)}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { filteredFlightDetails, flightFilters, serverOffSet, refreshedTime } = state.flightDetail;
    const { allStations, JSONStringList } = state.StationDetail;
    //console.log("flighdetails componenet stations component", state.StationDetail);

    return {
        filteredFlightDetails,
        flightFilters,
        serverOffSet,
        allStations,
        JSONStringList,
        refreshedTime,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, flightDetailsActions, StationsActions), dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightDetails);
